import React from "react";
import Paper from "@material-ui/core/Paper";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
export default function LabTabs() {
  const [value, setValue] = React.useState(2);
  const [dived, setdived] = React.useState("none");
  
  return (
    <div
      style={{
        marginLeft: "40%",
      }}
    >
      <h2>How to Create Tabs in ReactJS?</h2>
      <Paper square>
        <Tabs
          value={value}
          textColor="primary"
          indicatorColor="primary"
          onChange={(event, newValue) => {
            setValue(newValue);
            setdived("block");
          }}
        >
          <Tab label="Active TAB One">
          </Tab> 
          <Tab label="Active TAB Two" />
          <Tab label="Disabled TAB!" disabled />
          <Tab label="Active Tab Three" />
        </Tabs>
        <div style={{display:dived}}>


        </div>
      </Paper>
    </div>
  );
};